// apps/account-portal/src/pages/ProfilePage.tsx
// 個人資料頁：版面與表單是 @redpanda/ui 的 ProfileSettings（各系統共用，R26），這裡只接 API 與 toast（同 CRM）
import React, { useContext } from 'react';
import { toast } from 'react-hot-toast';
import { ProfileSettings } from '@redpanda/ui';
import { identityApi } from '../services/api';
import { UserContext } from '../context/UserContext';
import { setCrossDomainCookie } from '@redpanda/utils';

// 重新整理時 user 要等 checkAuthStatus() 打完才有值，這段空窗用上次登入時快取的資料先畫出頁面，
// 避免每次重新整理都先看到「載入中」（快取由 UserContext 寫入，登出時清掉）
const readCache = (key: string) => {
  try { return localStorage.getItem(key); } catch { return null; }
};

const ProfilePage: React.FC = () => {
  const userContext = useContext(UserContext);
  const user = userContext?.user;
  const cachedEmail = readCache('cachedUserEmail');

  const displayUser = user
    ? { name: user.name, email: user.email, organizationName: user.organization?.name, role: user.role }
    : (userContext?.cachedUserId && cachedEmail
      ? {
          name: readCache('cachedUserName'),
          email: cachedEmail,
          organizationName: readCache('cachedUserOrganization') || undefined,
          role: userContext.cachedUserRole || undefined,
        }
      : null);

  return (
    <ProfileSettings
      isLoading={userContext?.isLoading}
      user={displayUser}
      onUpdateName={async (name) => {
        await identityApi.patch('/auth/me', { name });
        await userContext?.refreshUser();
      }}
      onChangePassword={async (oldPassword, newPassword) => {
        const { data: changed } = await identityApi.post('/auth/change-password', { oldPassword, newPassword });
        // 改密碼後其他裝置的登入會失效，這台換用回傳的新 token（寫回自己網域的 cookie）
        if (changed?.token) setCrossDomainCookie('auth_token', changed.token, '.redpanda-tech.com');
      }}
      notify={toast}
    />
  );
};

export default ProfilePage;
